import { render, staticRenderFns } from "./SystemPermissionManageBySystem.vue?vue&type=template&id=be7d37cc&scoped=true"
import script from "./SystemPermissionManageBySystem.vue?vue&type=script&lang=js"
export * from "./SystemPermissionManageBySystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7d37cc",
  null
  
)

export default component.exports